/* eslint-disable array-callback-return */
import React from 'react';
import { LidarLayer } from './LidarLayer';
import { ModelSetLayer } from './ModelSetLayer';
import { Acute3DLayer } from './Acute3DLayer';
import { PipelineLayre } from './PipelineLayer';
import { ModelLayer } from './ModelLayer';
import { ProjectorLayer } from './ProjectorLayer';
import { I3SLayer } from './I3SLayer';
import { ThreeDTilesLayer } from './3DTilesLayer';


class Layer3DGroup extends React.Component{
    constructor(){
        super();
        this.state = {
            List:[]
        };
    }
    componentDidMount(){
        let List = window.LAYER_GROUP_3DMODEL.LAYER;
        this.setState({List:List});
    }
    render(){
        const List = this.state.List;
        const deleteList = this.props.deleteList;
        return( 
            <div className="ts checkboxes">
                {
                    List.map(
                        (layer,index)=>
                        {
                            switch(layer.TYPE){
                                case "Lidar" :
                                    return <LidarLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "ModelSet":
                                    return <ModelSetLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "Acute3D":
                                    return <Acute3DLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "Pipeline":
                                    return <PipelineLayre layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "Model":
                                    return <ModelLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "Projector":
                                    return <ProjectorLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "I3S":
                                    return <I3SLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;
                                case "3DTiles":
                                    return <ThreeDTilesLayer layer={layer} setOpenLayer = {(layer,layerHandel)=>this.props.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.props.deleteLayer(layer)} deleteList={deleteList}/>;

                                default:
                                    break;
                            }
                        }
                    )
                }
            </div>           
        );
    }
}

export default Layer3DGroup;